enum SiteTheme {
  NccerSSO = 'nccer-sso',
  NccerBilling = 'nccer-billing',
}
export default SiteTheme;
